import React from 'react';
import { Heart, Sparkles, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const SimulatorCTA = () => {
  const navigate = useNavigate();

  return (
    <section className="py-20 px-6 bg-transparent">
      <div className="max-w-5xl mx-auto">
        <div className="relative bg-gradient-to-br from-[#D4C4B0]/40 via-[#E8D5D5]/30 to-[#B5C4B1]/40 rounded-3xl p-8 md:p-12 lg:p-16 overflow-hidden">
          {/* Decorative Elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#B5C4B1]/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-[#D4C4B0]/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" />
          
          <div className="relative z-10 grid md:grid-cols-2 gap-8 items-center">
            {/* Content */}
            <div>
              {/* Badge */}
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/70 backdrop-blur-sm rounded-full text-sm text-[#6B4E37] mb-6 shadow-sm">
                <Sparkles size={16} className="text-[#C4B5A0]" />
                Novo: Experiência Interativa
              </div>

              <h2 className="font-['Cormorant_Garamond'] text-3xl md:text-4xl lg:text-5xl text-[#2C2C2C] mb-4 leading-tight">
                Simulador Emocional do Casamento
              </h2>

              <p className="text-[#6B4E37] text-lg mb-6 leading-relaxed">
                Descubram o vosso perfil de casamento e tomem decisões mais conscientes, 
                alinhadas com os vossos valores e prioridades reais.
              </p>

              <ul className="space-y-3 mb-8">
                <li className="flex items-center gap-3 text-[#6B4E37]">
                  <span className="w-6 h-6 rounded-full bg-[#B5C4B1]/40 flex items-center justify-center">
                    <span className="w-2 h-2 rounded-full bg-[#6B4E37]" />
                  </span>
                  Identifiquem o vosso perfil emocional
                </li>
                <li className="flex items-center gap-3 text-[#6B4E37]">
                  <span className="w-6 h-6 rounded-full bg-[#D4C4B0]/40 flex items-center justify-center">
                    <span className="w-2 h-2 rounded-full bg-[#6B4E37]" />
                  </span>
                  Descubram onde investir e onde poupar
                </li>
                <li className="flex items-center gap-3 text-[#6B4E37]">
                  <span className="w-6 h-6 rounded-full bg-[#E8D5D5]/40 flex items-center justify-center">
                    <span className="w-2 h-2 rounded-full bg-[#6B4E37]" />
                  </span>
                  Recebam recomendações personalizadas
                </li>
              </ul>

              <button
                onClick={() => navigate('/simulador')}
                className="inline-flex items-center gap-3 px-8 py-4 bg-[#C4B5A0] text-white rounded-lg font-medium hover:bg-[#6B4E37] transition-all duration-300 shadow-md hover:shadow-lg"
              >
                Começar Simulador
                <ArrowRight size={20} />
              </button>

              <p className="text-sm text-[#8B7D6B] mt-4">
                5 minutos · 8 perguntas · Gratuito
              </p>
            </div>

            {/* Visual */}
            <div className="hidden md:flex items-center justify-center">
              <div className="relative">
                {/* Main Icon */}
                <div className="w-48 h-48 rounded-full bg-white/60 backdrop-blur-sm flex items-center justify-center shadow-xl">
                  <Heart size={72} className="text-[#C4B5A0]" />
                </div>
                
                {/* Floating Elements */}
                <div className="absolute -top-4 -right-4 w-16 h-16 rounded-full bg-[#B5C4B1]/60 flex items-center justify-center shadow-lg animate-bounce" style={{ animationDuration: '3s' }}>
                  <span className="text-2xl">🎯</span>
                </div>
                <div className="absolute -bottom-2 -left-6 w-14 h-14 rounded-full bg-[#D4C4B0]/60 flex items-center justify-center shadow-lg animate-bounce" style={{ animationDuration: '2.5s', animationDelay: '0.5s' }}>
                  <span className="text-xl">💡</span>
                </div>
                <div className="absolute top-1/2 -right-8 w-12 h-12 rounded-full bg-[#E8D5D5]/60 flex items-center justify-center shadow-lg animate-bounce" style={{ animationDuration: '2s', animationDelay: '1s' }}>
                  <span className="text-lg">✨</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SimulatorCTA;
